import { render, staticRenderFns } from "./QuFlightItem.vue?vue&type=template&id=984a0624&scoped=true&"
import script from "./QuFlightItem.vue?vue&type=script&lang=js&"
export * from "./QuFlightItem.vue?vue&type=script&lang=js&"
import style0 from "./QuFlightItem.vue?vue&type=style&index=0&id=984a0624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984a0624",
  null
  
)

export default component.exports